import { FC } from 'react'
import { Text } from '@blueprintjs/core'
import { ResponsiveBlock } from 'client/components/ResponsiveBlock/ResponsiveBlock'
import Checked from 'images/checked.svg?react'
import Leaf from 'images/leaf.svg?react'

type TProps = {}

const LIST = [
  // 'Конструктор сайтов',
  'Быстрое оформление заказа',
  'Онлайн-курсы',
  // 'Поддержка налогов',
  'Цифровые загрузки',
  'Поддержка 20+ валют',
  'Подписки/Членства',
  'Дополнительные продажи (upsell)',
  // 'Лендинги',
  // 'Предпродажи',

  'Блог',
  'Партнёрский маркетинг',
  'Шаблоны',
  'Вебинары',
  // 'Встроенное SEO',
  'Коучинговые продукты',
  // 'Email-маркетинг',
  // 'Купоны',
  // 'Email-автоматизация',
  'Мультимедийные продукты',
]

const ListBlock: FC<TProps> = () => {
  return (
    <ResponsiveBlock className="bg-palette-grey py-12">
      <div className="flex flex-1 flex-col gap-20 pr-12">
        <div className="flex flex-col gap-4">
          <Text tagName="span" className="font-body---40px">
            Всё для запуска и роста вашего бизнеса — в одном месте.
          </Text>
          <Text tagName="span" className="font-body---24px text-palette-grey--50">
            Забудьте о десятках сервисов для контента, email-маркетинга и<br />
            онлайн-продаж. С D-Console вы управляете всем бизнесом на
            <br />
            одной платформе — быстро, удобно и без лишних сложностей.
          </Text>
          <Text tagName="span" className="font-body---24px text-palette-grey--50">
            – Elena Milosevic, Reformer Puls, Serbia
          </Text>
        </div>
        <div className="flex flex-col gap-4">
          <Leaf />
          <Text tagName="span" className="font-body---32px">
            Создано для масштабирования.
          </Text>
          <Text tagName="span" className="font-body---24px text-palette-grey--50">
            Мечтайте по-крупному — никаких ограничений на то, сколько вы можете зарабатывать.
          </Text>
        </div>
      </div>
      <div className="flex ">
        <ul className="grid grid-cols-2 gap-x-12">
          {LIST.map((item, index) => (
            <li key={index} className="flex items-center gap-2">
              <Checked className="flex-none" />
              <Text tagName="span" className="font-body---24px whitespace-nowrap text-palette-grey--50">
                {item}
              </Text>
            </li>
          ))}
        </ul>
      </div>
    </ResponsiveBlock>
  )
}

export { ListBlock }
